const styles = theme => ({
  footer: {
    backgroundColor: theme.color.white,
    position: 'relative',
    padding: '0 20px 24px 30px',
  },
});

export default styles;
